import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getProjectConfig, isMultiProjectMode } from './config-loader';

// Load config dynamically based on subdomain/URL param/localStorage
const config = getProjectConfig();

// Log which mode we're in (helpful for debugging)
if (isMultiProjectMode()) {
  console.log(`[Firebase] Multi-project mode: ${config.companySlug} (${config.companyName})`);
} else {
  console.log('[Firebase] Single-company fallback mode');
}

// Initialize Firebase
// CRITICAL: Use DEFAULT app for single-company mode to maintain backward compatibility
// with existing auth, Firestore, and Storage imports across the codebase.
// Named apps are only used in true multi-project mode.
let app;
if (isMultiProjectMode() && config.projectId) {
  app = initializeApp(config, config.projectId);
} else {
  app = initializeApp(config);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Export the current project config for branding, Zoho settings, etc.
export const currentProject = config;
export { isMultiProjectMode };
